import React from 'react';

import CartCell from '../../Cell/Cart';
import SpotlioIcon from '../../Icon';

import { getSystemSettings } from '../../../utils/SettingsRetriever';
import LocaleAsString from '../../../LocaleEngine/LocaleAsString';


export default function Agrupation(props){
    const { agrupation, idx } = props;

    function removeItemModalOpen(item, value){
        props.deleteItem(item, value)
    }

    function removePackageModalOpen(Package, value){
        props.removePackage(Package, value)
    }

    function getBundle(itemId){
        props.getBundle(itemId);
    }
    return (
        <div className="agrupation" key={idx}>
            <div className="header">
                <span className="icon"><SpotlioIcon icon={agrupation.icon} /></span> {agrupation.name}
                {
                    agrupation.supercategoryid === 0 && props.readOnly !== true
                    ?
                    <div onClick={()=>removePackageModalOpen(agrupation, true)}className="remove-package">
                        <SpotlioIcon icon={"feather-trash-2"} size={24} />
                        <span>
                            {
                                getSystemSettings().app && getSystemSettings().app && getSystemSettings().app.removePackageWord ?
                                "Remove" :
                                LocaleAsString("cart.remove_item.buttons.remove_package")
                            }
                        </span>
                    </div>
                    :
                    null
                }
            </div>
            {
                agrupation.items && agrupation.items.length > 0 && agrupation.items.map((item, index) => {
                    return (<CartCell readOnly={props.readOnly} bundleConfig={props.bundleConfig} getBundle={getBundle.bind(this)} key={index} deleteItem={removeItemModalOpen.bind(this)} index={index} agrupation={agrupation} item={item} />)
                })
            }
        </div>
    )
}
